export default __webpack_public_path__ + "static/media/discord.31fd8be8.svg";